import {LoadingOutlined} from "@ant-design/icons";
import {Spin} from "antd";
import React from "react";
import "./Loading.scss";

interface IProps {
  className?: string;
  size?: "small" | "default" | "large";
}

const Loading = (props: IProps) => {

  const loading = <LoadingOutlined spin/>;

  return (
    <Spin
      className={props.className ?? 'loading'}
      size={props.size ?? "default"}
      indicator={loading}
    />
  );
}

export default Loading;
